<script setup lang="ts">
  import type { RadioGroupRootEmits, RadioGroupRootProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';
  import { reactiveOmit } from '@vueuse/core';
  import { RadioGroupRoot, useForwardPropsEmits } from 'reka-ui';
  import { cn } from '@/lib/utils';

  const props = defineProps<RadioGroupRootProps & { class?: HTMLAttributes['class'] }>();
  const emits = defineEmits<RadioGroupRootEmits>();

  const delegatedProps = reactiveOmit(props, 'class');

  const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <RadioGroupRoot data-slot="radio-group" :class="cn('grid gap-3', props.class)" v-bind="forwarded">
    <slot />
  </RadioGroupRoot>
</template>
